import { Controller } from "@hotwired/stimulus"

/**
 * Row Accordion controller - クリックで対応する詳細行 (<tr>) を展開／折り畳む。
 * 詳細行内に log-viewer controller があれば open/close を呼んで読み込み開始も連動させる。
 *
 * Usage:
 *   <tr data-controller="row-accordion"
 *       data-row-accordion-detail-id-value="status-log-detail-123">
 *     <td>
 *       <button type="button" data-action="click->row-accordion#toggle">
 *         <span data-row-accordion-target="chevron" class="transition-transform">▶</span>
 *         ログを表示
 *       </button>
 *     </td>
 *   </tr>
 *   <tr id="status-log-detail-123" class="hidden">
 *     <td colspan="N"> ... </td>
 *   </tr>
 */
export default class extends Controller {
  static targets = ["chevron"]
  static values = { detailId: String }

  toggle(event) {
    event?.preventDefault()

    const detail = this.detailElement
    if (!detail) return

    const willOpen = detail.classList.contains("hidden")
    detail.classList.toggle("hidden", !willOpen)

    this.updateChevron(willOpen)
    this.notifyLogViewer(detail, willOpen)
  }

  get detailElement() {
    if (!this.detailIdValue) return null
    return document.getElementById(this.detailIdValue)
  }

  updateChevron(isOpen) {
    if (!this.hasChevronTarget) return
    this.chevronTarget.classList.toggle("rotate-90", isOpen)
  }

  notifyLogViewer(detail, willOpen) {
    const viewerEl = detail.querySelector('[data-controller~="log-viewer"]')
    if (!viewerEl) return

    const ctrl = this.application.getControllerForElementAndIdentifier(viewerEl, "log-viewer")
    if (!ctrl) return

    if (willOpen) {
      ctrl.open()
    } else {
      ctrl.close()
    }
  }
}
